// Fichier: Animation.js
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class Animation {
  constructor(element) {
    /**
     * @param {HTMLElement} element - L'élément du DOM à animer.
     */

    this.element = element;
    this.setInitialState();
    this.timeline = this.createTimeline();
  }


  setInitialState() {
  }

  initScrollTrigger() {
    // Initialisation de ScrollTrigger pour cette animation
    this.ScrollTriggerInstance = ScrollTrigger.create({
      trigger: this.element,
      animation: this.timeline,
      start: "top 80%", // Se déclenche quand le haut de l'élément atteint 80% du bas de l'écran
      toggleActions: "play none none none", // Utile pour le débogage
      // markers: true, // Décommenter pour voir les marqueurs de début/fin
      // enabled: false, // Désactivé par défaut, peut être activé dans les classes enfants
    });
  }

  start() {
    this.initScrollTrigger();
  }

  createTimeline() {
    return gsap.timeline({ paused: true });
  }

  kill() {
    // On tue l'instance ScrollTrigger si elle existe
    if (this.ScrollTriggerInstance) {
      this.ScrollTriggerInstance.kill();
    }

    // On tue la timeline GSAP si elle existe
    if (this.timeline) {
      this.timeline.kill();
    }
  }
}
